import dayjs from 'dayjs';
export default {
    loading: (state) => (item) => state.loading[item],
    list: (state) => state.list,
    filters: (state) => state.filters,
    searchQuery: (state) => state.searchQuery,
    activeFilters: ({ filters }) => {
        let activeFilters = [];

        filters.forEach((filter, filterIndex) => {
            if (!filter.value) return;

            switch (filter.type) {
                case 'list': {
                    const activeValueList = [];
                    filter.value.forEach(
                        ({ value, id, active }, optionIndex) => {
                            if (active)
                                activeValueList.push({
                                    value,
                                    id,
                                    optionIndex,
                                });
                        }
                    );

                    if (activeValueList.length == 0) break;

                    activeValueList.forEach((value) => {
                        activeFilters.push({
                            name: filter.name,
                            type: filter.type,
                            filterIndex,
                            value,
                        });
                    });
                    break;
                }

                case 'date': {
                    activeFilters.push({
                        name: filter.name,
                        type: 'date',
                        filterIndex,
                        value: dayjs(filter.value).format('MMMM D, YYYY'),
                    });
                    break;
                }

                default: {
                    activeFilters.push({
                        name: filter.name,
                        type: filter.type,
                        filterIndex,
                        value: filter.value,
                    });
                    break;
                }
            }
        });

        return activeFilters;
    },
    apiUrl: (state, getters) => {
        let filterObject = {};

        getters.activeFilters.forEach(({ name, value }) => {
            switch (name) {
                case 'Search': {
                    filterObject['search'] = encodeURIComponent(
                        value.toLowerCase()
                    );
                    break;
                }
                case 'Date to': {
                    filterObject['dateto'] = dayjs(value).format('MMM-DD-YYYY');
                    break;
                }
                case 'Date from': {
                    filterObject['datefrom'] = dayjs(value).format(
                        'MMM-DD-YYYY'
                    );
                    break;
                }
                case 'Type':
                case 'Publishers':
                    if (
                        typeof filterObject[name.toLowerCase()] == 'undefined'
                    ) {
                        filterObject[name.toLowerCase()] = [];
                    }

                    filterObject[name.toLowerCase()].push(
                        encodeURIComponent(value.value)
                    );
                    break;
                default:
                    break;
            }
        });
        let query = [];

        Object.keys(filterObject).forEach((filter) => {
            if (Array.isArray(filterObject[filter])) {
                query.push(`${filter}=${filterObject[filter].join(',')}`);
            } else {
                query.push(`${filter}=${filterObject[filter]}`);
            }
        });

        let url = `${process.env.VUE_APP_API_ROOT}/wp-json/com/v1/publication/?current_page=${getters.page}`;

        if (query.length > 0) {
            url += `&${query.join('&')}`;
        }

        return url;
    },
    totalPages: (state) => state.totalPages,
    totalPosts: (state) => state.totalPosts,
    page: (state) => state.page,
};
